"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledGrid = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _getStyled = require("../helper/getStyled.js");
var _breakpoint = require("../../../../theme/breakpoints/breakpoint.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const loadMediaQuery = breakpoint => {
  const styledWidth = (0, _getStyled.getStyleWidth)(breakpoint);
  return breakpoint ? `
		flex-basis: ${styledWidth};
		max-width: ${styledWidth === 'auto' ? 'none' : styledWidth};
	` : '';
};
const cssLoader = (key, value) => {
  if (!value) return ``;
  return `${key}:${value};`;
};
const StyledGrid = exports.StyledGrid = _styledComponents.default.div`
	${({
  xs,
  sm,
  md,
  lg,
  xl,
  xxl,
  spacing = 0,
  themeSpacing,
  direction,
  container,
  background,
  justifyContent,
  alignItems,
  height,
  width,
  colSpacing,
  maxWidth,
  borderRadius,
  flexWrap,
  padding,
  overflow,
  gap
}) => {
  let flexDirection = direction ?? 'row';
  const commonStyles = `
			${cssLoader('background', background)};
			${cssLoader('justify-content', justifyContent)};
			${cssLoader('align-items', alignItems)};
			${cssLoader('height', height)};
			${cssLoader('width', width)};
			${cssLoader('max-width', maxWidth)};
			${cssLoader('border-radius', borderRadius)};
			${cssLoader('flex-wrap', flexWrap)};
			${cssLoader('padding', padding)};
			${cssLoader('overflow', overflow)};
		`;
  if (container) return (0, _styledComponents.css)`
				display: flex;
				flex-direction: ${flexDirection};
				flex-wrap: wrap;
				box-sizing: border-box;
				${commonStyles};
				${!padding && (spacing || colSpacing) ? (0, _styledComponents.css)`
							> .mun-grid-item {
								padding: ${themeSpacing * spacing}px ${themeSpacing * (colSpacing ?? spacing)}px;
							}
					  ` : ''}
				${!padding && gap ? (0, _styledComponents.css)`
							> .mun-grid-item {
								padding-left: ${gap / 2}px;
								padding-right: ${gap / 2}px;
								&:first-child {
									padding-left: 0;
								}

								&:last-child {
									padding-right: 0;
								}
							}
					  ` : ''}
			`;
  return `
            flex-grow: 0;
            max-width: ${maxWidth ? maxWidth : 'auto'};
            box-sizing: border-box;
			@media ${_breakpoint.device.xs}{
                ${loadMediaQuery(xs)}
            };
			@media ${_breakpoint.device.sm}{
                ${loadMediaQuery(sm)}
            };
            @media ${_breakpoint.device.md}{
                ${loadMediaQuery(md)}
            };
            @media ${_breakpoint.device.lg}{
                ${loadMediaQuery(lg)}
            };
            @media ${_breakpoint.device.xl}{
                ${loadMediaQuery(xl)}
            };
			@media ${_breakpoint.device.xxl}{
                ${loadMediaQuery(xxl)}
            };
			${commonStyles};
        `;
}}
`;